import HeroContent from './HeroContent';

export default HeroContent;



// WEBPACK FOOTER //
// ./src/universal/components/HeroContent/index.js